import { Pipe, PipeTransform } from '@angular/core';
import { TeamEntryType } from 'src/app/recruiting/candidates/new-profile/team-info/enums/team-info.enum';

@Pipe({ name: 'teamEntryText', standalone: true })
export class TeamEntryTextPipe implements PipeTransform {
    transform(value: TeamEntryType): string {
        switch (value) {
            case TeamEntryType.Recruiter:
                return 'Recruiter';
            case TeamEntryType.CredentialingSpecialist:
                return 'Credentialing Specialist';
            case TeamEntryType.Leader:
                return 'Team Leader';
            case TeamEntryType.PayrollPre:
                return 'Payroll Pre-Start';
            case TeamEntryType.PayrollWor:
                return 'Payroll Current';
            case TeamEntryType.PerDiemRecruiter:
                return 'PD Recruiter';
            case TeamEntryType.TravelXEscalation:
                return 'Experience Escalation';
            case TeamEntryType.TravelXSpecialist:
                return 'Experience Specialist';
            case TeamEntryType.PermanentRecruiter:
                return 'Permanent Recruiter';
            case TeamEntryType.AccessControlRecruiter:
                return 'Access Control Manager';
            default:
                return `${value} unrecognized`;
        }
    }
}
